/*
 * Coordinates with the Nova currency-converter app embed (not theme-owned):
 * - relocates its floating pill into the header (desktop) or the persistent mobile header slot
 *   (mobile), site-wide, with a fallback that nudges it clear of the mobile sticky "Add to bag"
 *   bar if relocation hasn't happened yet
 * - hides the theme-rendered "IDR ... charged" line when the shopper has picked IDR
 * - hides the customer-currency price until Nova has converted it, to avoid a visible swap
 * - mirrors Nova's chosen currency into every [data-amore-currency-code] label, but only once
 *   the price(s) next to that specific label have actually been converted (see codeForNode)
 * - re-kicks Nova's conversion after Dawn replaces cart sections on quantity change, since Nova
 *   sometimes misses / lags the replacement (see restartNovaOnCartUpdate)
 * Nova exposes no public API/event beyond `window.baCurr.refreshConversion()`, so this reads its
 * DOM (`.bacurr-cur-block`, `.ba-chosen`) and falls back to a timeout/poll if Nova never loads.
 */
(function () {
  /* FIX-04: гейт видимости пилюли до первого успешного переноса. Между вставкой
     `.bacurr-cur-block` в DOM (Nova) и `tryMove()` (ниже) минимум один кадр рисуется с
     пилюлей в РОДНОМ углу Nova (`position:fixed`, свой z-index) — на мобильной этот угол
     совпадает с зоной липкой полосы Add to cart (`.amore-pdp-stick`), и пилюля рисуется
     поверх кнопки. Подтверждено 27.08 (`document.elementFromPoint()` в момент гонки
     возвращает `.ba-chosen` — то есть сама пилюля, а не полоса или кнопка — самый верхний
     элемент в точке их пересечения; на PNG-снимке кадр поймать не удалось — скриншот,
     снятый сразу после `scrollTo()`, систематически отдаёт композит ДО прокрутки для
     `position:fixed`-контента, ровно ловушка из наряда).
     Правило ниже прячет пилюлю (`visibility`, не `display` — без сдвига раскладки) до тех
     пор, пока `applyPillStyles()` не отметит её размеченной; снимается ОДИН раз и навсегда
     для этого узла. На смену валюты не действует — переключение того же узла (проверено:
     0 плохих кадров на 3с логирования вокруг реального клика IDR→USD) эту гонку не создаёт,
     ре-пряталка тут не нужна. */
  var pillVisibilityGate = document.createElement('style');
  pillVisibilityGate.textContent =
    '.bacurr-cur-block:not([data-amore-currency-placed]) { visibility: hidden !important; }';
  (document.head || document.documentElement).appendChild(pillVisibilityGate);

  /* Символ -> код. Плашка Nova показывает не код, а символ валюты, и на рупии
     это стоило нам гейта: `Rp` — две буквы, шаблон трёхбуквенного кода их не
     видел, функция возвращала null, и строка «IDR N charged» оставалась на
     экране рядом с ценой в тех же рупиях (замер 19.08: `Rp` и `Rp 56 160 000`
     не гейтятся, `IDR` гейтится).
     Порядок важен: сначала составные символы, потом одиночные, иначе `C$`
     схлопнется в USD, а `CN¥` — в JPY. Одиночные `$` и `¥` отданы самым
     частым владельцам (USD, JPY) — так их и печатает Nova на витрине.
     Источник по-прежнему ТОЛЬКО видимая плашка: скрытый `#baCurrSelector`
     читать нельзя, порядок чтения перевёрнут 30.07 после того, как он
     показывал USD при плашке и ценах в EUR. */
  /* Одиннадцать валют Nova сняты с живого виджета 19.08 (`li.currMovers`):
     USD EUR GBP CAD IDR CNY AUD JPY AED SGD RUB. Строки — те, которыми Nova
     печатает суммы (замер там же, переключением каждой валюты):
       USD $190 · EUR €164 · GBP £140 · CAD $264 · CNY ¥1,279 · AUD $268
       JPY ¥30,264 · AED Dhs. 697 · SGD $242 · RUB руб16.124 · IDR 3 400 000
     Отсюда два вывода. Первый: `$` и `¥` неоднозначны — Nova печатает их и
     для CAD/AUD/SGD, и для CNY/JPY. Для `¥` решение владельца 19.08:
     НЕ УГАДЫВАТЬ, возвращать null — `¥1,279` (CNY) и `¥30,264` (JPY)
     составными формами не различаются, а неверный код хуже отсутствующего.
     Отсутствие кода просто оставляет строку списания на экране, неверный —
     прячет её при чужой валюте. `$` по тому же решению оставлен за USD.
     Второй: у рупии символа в сумме нет вовсе, `Rp` приходит из money_format
     магазина (сервер печатает `Rp 3 400 000`) — и именно эта форма попадает
     в плашку, из-за чего трёхбуквенный шаблон её не видел. */
  var CURRENCY_SYMBOL_CODES = [
    ['HK$', 'HKD'],
    ['NZ$', 'NZD'],
    ['C$', 'CAD'],
    ['A$', 'AUD'],
    ['S$', 'SGD'],
    ['DHS', 'AED'],
    ['د.إ', 'AED'],
    ['РУБ', 'RUB'],
    ['₽', 'RUB'],
    ['RM', 'MYR'],
    ['RP', 'IDR'],
    ['₫', 'VND'],
    ['฿', 'THB'],
    ['₱', 'PHP'],
    ['₹', 'INR'],
    ['₩', 'KRW'],
    ['£', 'GBP'],
    ['€', 'EUR'],
    ['$', 'USD']
  ];

  function normalizeCurrency(value) {
    var text = String(value || '').toUpperCase();
    var match = text.match(/\b[A-Z]{3}\b/);
    if (match) return match[0];
    for (var i = 0; i < CURRENCY_SYMBOL_CODES.length; i++) {
      if (text.indexOf(CURRENCY_SYMBOL_CODES[i][0]) !== -1) return CURRENCY_SYMBOL_CODES[i][1];
    }
    return null;
  }

  // Read the actually-selected currency from Nova's visible pill text first (`.ba-chosen`,
  // scoped under `.bacurr-choiceDesign` where present) rather than the whole choice-design
  // block's textContent, which can include unrelated dropdown markup. The hidden
  // `#baCurrSelector` can lag behind the visible choice, so it's a last-resort fallback only.
  function currentNovaCurrency() {
    var visibleChosen = document.querySelector('.bacurr-choiceDesign .ba-chosen');
    var currency = normalizeCurrency(visibleChosen && visibleChosen.textContent);
    if (currency) return currency;

    var chosen = document.querySelector('.ba-chosen');
    currency = normalizeCurrency(chosen && chosen.textContent);
    if (currency) return currency;

    var select = document.getElementById('baCurrSelector');
    return normalizeCurrency(select && select.value);
  }

  /* Пустой ответ `currentNovaCurrency()` означает РАЗНОЕ в двух случаях, и
     умолчания у них тоже разные (решение владельца 19.08):
       — цены уже сконвертированы, а плашку прочитать нельзя (виджет скрыт
         настройками Nova, не отрисован на поверхности, пересоздаётся);
       — Nova не работала вовсе, и на экране серверные рупии.
     Отличить их можно только по самим суммам: хотя бы один узел с меткой
     Nova, чей текст уже не в рупиях, означает первый случай. */
  function hasConvertedMoney() {
    var nodes = document.querySelectorAll('.money.bacurr-money');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].closest('[data-amore-idr-line]')) continue;
      if (!isIdrMoneyText(nodes[i].textContent)) return true;
    }
    return false;
  }

  function updateIdrLines() {
    /* Валюта не прочиталась — решает наличие сконвертированных сумм, тот же
       признак, что и у формата, но вывод из него другой:
         есть сконвертированные → валюта чужая, какая именно неизвестно →
           строку ПОКАЗЫВАЕМ. Скрытая подпись при оплате в долларах ломает
           обещание покупателю, а лишняя видимая безвредна;
         сконвертированных нет → на экране серверные рупии → строку СКРЫВАЕМ,
           рядом с ценой в рупиях она сообщает нолик. */
    var currency = currentNovaCurrency();
    if (!currency && !hasConvertedMoney()) currency = 'IDR';
    var lines = document.querySelectorAll('[data-amore-idr-line]');
    for (var i = 0; i < lines.length; i++) {
      lines[i].hidden = currency === 'IDR';
    }
  }

  function isIdrMoneyText(value) {
    return /(?:\bIDR\b|\bRp\b)/i.test(String(value || ''));
  }

  // The `.money` node(s) a given [data-amore-currency-code] label speaks for. Every existing
  // chip in the theme sits next to its price inside a shared parent (e.g. the PDP price
  // paragraph, a Complete-the-look line item, the cart totals row) with no other price mixed
  // into that parent, so the immediate parentElement is a reliable scope.
  function moneyNodesForCode(codeNode) {
    var scope = codeNode && codeNode.parentElement;
    if (!scope) return [];
    return Array.prototype.filter.call(scope.querySelectorAll('.money'), function (moneyNode) {
      return !moneyNode.closest('[data-amore-idr-line]');
    });
  }

  // A label only switches to the shopper's currency once every price it covers has actually
  // been converted by Nova (`.bacurr-money`, not still reading IDR/Rp). Until then it stays
  // "IDR" so the number on screen and its label never disagree.
  function codeForNode(codeNode, requestedCurrency) {
    if (requestedCurrency === 'IDR') return 'IDR';

    var moneyNodes = moneyNodesForCode(codeNode);
    if (!moneyNodes.length) return 'IDR';

    var converted = moneyNodes.every(function (moneyNode) {
      var sourceAmount = moneyNode.getAttribute('data-amore-idr-amount');
      var displayedAmount = String(moneyNode.textContent || '').replace(/\s+/g, ' ').trim();
      var sourceChanged = sourceAmount !== null && displayedAmount !== sourceAmount.replace(/\s+/g, ' ').trim();
      return !isIdrMoneyText(displayedAmount) && (moneyNode.classList.contains('bacurr-money') || sourceChanged);
    });

    return converted ? requestedCurrency : 'IDR';
  }

  /* CURRENCY CODE: mirror Nova's chosen currency into every [data-amore-currency-code] label,
     but per-label, gated on that label's own price(s) being converted (see codeForNode) — not
     a single site-wide currency read applied blindly to every chip, which showed the shopper's
     currency next to a price still reading in IDR whenever Nova hadn't converted it yet. */
  function updateCurrencyCodes() {
    try {
      var requestedCurrency = currentNovaCurrency();
      if (!requestedCurrency) {
        // Есть сконвертированные суммы, а валюта не читается — не трогаем
        // ни чипы, ни текст: сырой `$162` лучше ложного `162 IDR`.
        if (hasConvertedMoney()) return;
        requestedCurrency = 'IDR';
      }
      var nodes = document.querySelectorAll('[data-amore-currency-code]');
      for (var i = 0; i < nodes.length; i++) {
        nodes[i].textContent = codeForNode(nodes[i], requestedCurrency);
      }
      normalizeMoneyFormat();
    } catch (e) {}
  }

  /* ФОРМАТ ЦЕНЫ — прототип priceText() (:2773-2784): число, пробел, код валюты.
     Символа валюты нет нигде. Nova форматирует символом ($191, Rp 2 900 000),
     а разметка добавляет код рядом — получалось двойное обозначение «$191 USD».
     Настройки формата у Nova в теме нет (её конфиг живёт в приложении), поэтому
     это постобработка ПОСЛЕ конвертации: правится только текст готового узла,
     сама конвертация не трогается.
     Разделитель разрядов — пробел, как в прототипе (`replace(/\B(?=(\d{3})+(?!\d))/g, ' ')`). */
  /* Список обязан покрывать ВСЕ одиннадцать валют Nova и все формы, которыми
     она печатает суммы. 19.08 на превью черновика поймано: RUB и AED в нём
     отсутствовали, поэтому у них прежний код не срезался, и каждый проход
     дописывал ещё один — цена вырастала в «руб613.753 RUB RUB RUB RUB…»
     (скриншот в отчёте). Дефект предсуществующий, вылезает только на этих
     двух валютах. */
  var CURRENCY_SYMBOLS = /[$€£¥₩₫₽]|\bRp\b|Dhs\.?|руб|\b(?:IDR|USD|EUR|GBP|AUD|CAD|JPY|CNY|SGD|AED|RUB)\b/gi;

  function normalizeMoneyFormat() {
    var requested = currentNovaCurrency();
    if (!requested) {
      // То же правило, что и для чипов: не подписываем чужую сумму рупиями.
      if (hasConvertedMoney()) return;
      requested = 'IDR';
    }
    var moneyNodes = document.querySelectorAll('.money');
    for (var i = 0; i < moneyNodes.length; i++) {
      var node = moneyNodes[i];
      // Служебная строка списания форматируется отдельно и своим шаблоном.
      if (node.closest('[data-amore-idr-line]')) continue;

      var raw = node.textContent;
      if (!raw || !/\d/.test(raw)) continue;

      var stripped = raw.replace(CURRENCY_SYMBOLS, '');
      // Разряды к пробелам, десятичный хвост ",00"/".00" убираем — в каталоге
      // все суммы целые, а хвост ломает разрядку.
      stripped = stripped
        .replace(/[.,]\d{2}\b\s*$/, '')
        .replace(/,/g, ' ')
        // Точка бывает десятичным разделителем, поэтому она уходит в пробел
        // ТОЛЬКО в шаблоне групп по три цифры: `13.753` и `2.900.000` — да,
        // `13.75` — нет. У Nova включён `round_style: removeDecimal`, дробной
        // части быть не должно, но проверка стоит на случай смены настройки.
        .replace(/\b\d{1,3}(?:\.\d{3})+\b/g, function (group) {
          return group.replace(/\./g, ' ');
        })
        .replace(/\s+/g, ' ')
        .trim();
      if (!stripped) continue;

      // Код валюты — часть той же текстовой строки, тем же кеглем и цветом
      // (прототип priceText(), :2781: `189 USD`). Отдельного чипа больше нет.
      var converted = node.classList.contains('bacurr-money') && !isIdrMoneyText(raw);

      // R1/R2: узел, который ЖДЁТ конвертации, не трогаем вовсе. Иначе после
      // смены варианта на PDP мы переписывали его текст раньше Nova и
      // запечатывали несконвертированную сумму — на витрине оставалась цена
      // прежнего варианта, а строка списания уже показывала новую.
      // Nova конвертирует свою же разметку; отняв её, мы ломаем пересчёт.
      if (requested !== 'IDR' && !converted) continue;

      var code = converted ? requested : 'IDR';
      var withCode = stripped + ' ' + code;

      if (node.textContent.trim() !== withCode) node.textContent = withCode;
    }
  }

  // Invariant: a `.money` node tagged `.bacurr-money` by Nova has been converted, so it must
  // not still read the store currency (`Rp ...`) — and the reverse, a node read as IDR must
  // not carry a foreign symbol/code. Nova occasionally tags a node `.bacurr-money` before (or
  // without) actually rewriting its text, leaving a stale `Rp` behind a chip that already
  // reads the shopper's currency. This repairs the node's own text in place; it does not touch
  // classes, does not hide anything, and is not itself a wait/observer — callers decide when to
  // run it (see the three call sites below).
  var repairForeignMoneyRequested = false;

  function stripRpToken(moneyNode) {
    var walker = document.createTreeWalker(moneyNode, NodeFilter.SHOW_TEXT, null);
    var textNode;
    while ((textNode = walker.nextNode())) {
      if (/\bRp\b/i.test(textNode.nodeValue)) {
        textNode.nodeValue = textNode.nodeValue.replace(/\s?\bRp\b\s?/gi, '');
      }
    }
  }

  function repairMixedMoneyNodes() {
    var cur = currentNovaCurrency();
    var nodes = document.querySelectorAll('.money.bacurr-money');

    if (cur === 'IDR') {
      var markerlessIdrNodes = document.querySelectorAll('.money[data-amore-price-no-rp]');
      for (var j = 0; j < markerlessIdrNodes.length; j++) {
        stripRpToken(markerlessIdrNodes[j]);
      }

      // Reverse case: shopper is on IDR but a converted node still carries a foreign
      // symbol/code. Ask Nova to reconvert once; don't retry every poll if it doesn't resolve.
      var hasForeignMoney = Array.prototype.some.call(nodes, function (moneyNode) {
        if (moneyNode.closest('[data-amore-idr-line]')) return false;
        return /[$€£]|\b[A-Z]{3}\b/.test(moneyNode.textContent);
      });
      if (hasForeignMoney && !repairForeignMoneyRequested) {
        repairForeignMoneyRequested = true;
        novaRefreshConversion();
      }
      return;
    }

    repairForeignMoneyRequested = false;

    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (node.closest('[data-amore-idr-line]')) continue;
      if (/\bRp\b/i.test(node.textContent)) {
        stripRpToken(node);
        node.setAttribute('data-amore-repaired', '');
      }
    }
  }

  // Exposed so other assets (golden-pdp.js) can resync chip labels right after a dynamic price
  // render instead of waiting for the next 400ms poll. Still the single owner of this logic —
  // callers just invoke the same function via this reference, they don't reimplement it.
  window.amoreUpdateCurrencyCodes = function () {
    repairMixedMoneyNodes();
    updateCurrencyCodes();
  };

  /* Nova's pill lives fixed bottom-right by default, floating over content everywhere it
     isn't explicitly relocated. It has one home per breakpoint: the header on desktop
     (`[data-amore-currency-slot="desktop"]`, see sections/amore-frame-header.liquid), or the
     mobile header's right group (`[data-amore-currency-slot="mobile"]`, in that same section). Both
     slots exist in the DOM on every page/template — there is exactly one pill, and this picks
     whichever slot matches the current breakpoint, moving it again on resize across the breakpoint.
     Mirrors the active Amore frame desktop cutover (900px).

     ПЕРЕПИСАНО 22.08.2026 (CUR-05, шаг 3). Прежний комментарий утверждал, что Nova
     пересоздаёт `.bacurr-cur-block` после смены валюты, и из этого выводил вечный
     наблюдатель. ЗАМЕРОМ ЭТО ОПРОВЕРГНУТО:

       · Монтирование у приложения одно и закрыто guard'ом
         `bacurr$(".bacurr-cur-blocker").length === 0` (booster_currency.js, функция `m`).
         Мы вынимаем пилюлю из обёртки, ПУСТАЯ ОБЁРТКА ОСТАЁТСЯ В `body`, guard навсегда
         сыт — повторного монтирования не бывает.
         ⚠️ ОБЁРТКУ НЕ ТРОГАТЬ. Удалить её значит разбудить guard и получить ВТОРУЮ пилюлю.
       · Три смены валюты и обновление корзины подряд: `.bacurr-cur-block` — тот же узел,
         `li.currMovers` — тот же узел, из слота не уезжал ни разу. Пересоздаётся только
         подпись `.ba-chosen` внутри пилюли.
       · `manual_placement: 'header a[href="/cart"]'` в конфиге — заводское умолчание Nova,
         оно читается лишь в ветке «не floating». У нас `display_position_type` и
         `mob_placement_type` оба `floating`, поэтому конфликта размещения нет вовсе.

     Значит задача не «пережить пересоздание», а «не пропустить появление» — один успешный
     перенос и всё. Отсюда три отличия от прежней версии.

     1. ФИЛЬТРА ЗАПИСЕЙ БОЛЬШЕ НЕТ. Прежний `relevantMutation` требовал, чтобы пилюля или
        слот пришли в `addedNodes`/`removedNodes`; любой другой путь появления проходил мимо.
        Разбирать записи и дороже, и ненадёжнее, чем просто проверить состояние: замер на
        живой PDP — 0,023 мс на проверку (20 000 прогонов). Всплеск «Add to cart» даёт
        205 записей мутаций, они склеиваются в 6 проверок, суммарно 0,138 мс. На устоявшейся
        странице за 11 с — 0 мутаций и 0 проверок.

     2. СКЛЕЙКА ЧЕРЕЗ `setTimeout(…, 0)`, А НЕ `requestAnimationFrame`. Это не вкусовщина:
        прежний планировщик поднимал флаг `moveScheduled` ДО вызова rAF и снимал его только
        внутри колбэка. В фоновой вкладке rAF не исполняется — замер: 0 кадров за 5 с при
        `document.hidden`, 9 кадров сразу после принудительной отрисовки. То есть первая же
        мутация запирала планировщик НАВСЕГДА, и перенос не происходил ни разу у всех, кто
        открыл магазин в фоновой вкладке (ссылка из соцсети, восстановление сессии).
        `setTimeout` в фоне тикает — с задержкой троттлинга, но тикает.

     3. НАБЛЮДАТЕЛЬ ЖИВЁТ, ПОКА ЖИВА СТРАНИЦА — но только если пилюля хоть раз нашлась.
        Первая версия этой правки отключала его на первом успехе; ЗАМЕР ЭТО ОТВЕРГ.
        Настоящим кликом сменил валюту GBP -> USD и получил сразу после смены:
          `ПЛАВАЮЩАЯ | pos=fixed bottom=40px z=2147483647 | список top=auto`
        то есть приложение вернуло пилюлю в свой угол И сбросило инлайновые стили, а
        одноразовый наблюдатель к тому моменту уже отключился, и чинить стало некому.
        Отсюда же и поправка к разбору шага 2: там три смены валюты «не двигали» пилюлю
        только потому, что прежний вечный наблюдатель молча возвращал её обратно — это
        было наблюдение следствия, а не причины.
        Условие остановки осталось ровно одно, и оно про страницы, где приложение вообще
        не загрузилось: если за 15 с пилюля не нашлась НИ РАЗУ, наблюдатель снимается и
        больше не висит. Как только успех был — наблюдатель остаётся навсегда, потому что
        цена этого измерена и ничтожна: 0 мутаций и 0 проверок на устоявшейся странице,
        0,138 мс на весь всплеск «Add to cart».
        Дополнительно включаемся заново там, где цель могла смениться: порог 900
        (слот desktop <-> mobile), перерисовка секции, `pageshow`, показ вкладки.

     `applyPillStyles()` по-прежнему зовётся на КАЖДОЙ успешной проверке, а не только на
     перемещении: приложение восстанавливает свои инлайновые стили, и без повторного
     применения пилюля осталась бы `position: fixed`, а список — с `top: -320px`. */
  function relocateNovaSelector() {
    var desktopQuery = window.matchMedia('(min-width: 900px)');

    function currentSlot() {
      var which = desktopQuery.matches ? 'desktop' : 'mobile';
      return document.querySelector('[data-amore-currency-slot="' + which + '"]');
    }

    function applyPillStyles(pill) {
      // Nova's own stylesheet sets position/bottom/right with !important and loads after
      // ours, so it wins the cascade on specificity/order. Inline !important outranks it.
      ['top', 'bottom', 'left', 'right', 'z-index'].forEach(function (prop) {
        pill.style.setProperty(prop, 'auto', 'important');
      });
      pill.style.setProperty('position', 'static', 'important');

      // FIX-04: снимает гейт видимости (см. `pillVisibilityGate` в шапке файла) — с этого
      // момента пилюля разрешена к показу навсегда для этого узла, независимо от того,
      // сколько раз applyPillStyles() ещё перевызовется (смена валюты, ресайз через 900px).
      pill.setAttribute('data-amore-currency-placed', '');

      // Nova's dropdown list opens with a hardcoded `top: -320px` — correct only when the
      // pill sits fixed at the bottom of the viewport (its normal home), which is where that
      // offset keeps the list on-screen. Relocated into a slot, the same offset pushes the
      // list off-screen above the viewport.
      var dropdown = pill.querySelector('.bacurr-dropdown-choices');
      if (dropdown) {
        dropdown.style.setProperty('top', '100%', 'important');
        dropdown.style.setProperty('bottom', 'auto', 'important');
        dropdown.style.setProperty('right', '0', 'important');
        dropdown.style.setProperty('left', 'auto', 'important');
        dropdown.style.setProperty('transform', 'none', 'important');
      }
    }

    function tryMove() {
      var pill = document.querySelector('.bacurr-cur-block');
      var slot = currentSlot();
      if (!pill || !slot) return false;
      if (pill.parentElement !== slot) {
        slot.appendChild(pill);
      }
      // Always re-apply, even when already correctly parented: Nova can reset the pill's own
      // inline styles (position/dropdown offset) on recreation without detaching it from the
      // slot, and a "no-op" here would leave stale/fixed styles in place.
      applyPillStyles(pill);
      return true;
    }

    var observer = null;
    var scheduled = false;
    var deadline = null;

    var everMoved = false;

    // Снимаем ТОЛЬКО срок, наблюдателя не трогаем: приложение возвращает пилюлю себе
    // при каждой смене валюты, чинить это некому, кроме него. Обёртку
    // `.bacurr-cur-blocker` не трогаем ни при каких условиях.
    function clearDeadline() {
      if (deadline) {
        window.clearTimeout(deadline);
        deadline = null;
      }
    }

    // Склейка всплеска в одну проверку. `queueMicrotask`, а не rAF — см. пункт 2 в шапке
    // (фон вкладки). FIX-04: раньше здесь стоял `setTimeout(…, 0)` — макрозадача, между
    // которой и колбэком MutationObserver браузер успевает нарисовать кадр с пилюлей ещё в
    // родном углу Nova (замер 27.08, см. комментарий у `pillVisibilityGate`). Микрозадача
    // выполняется до рисования кадра, того же тика, что и колбэк наблюдателя — щели больше
    // нет, а склейка всплеска сохранена (флаг `scheduled` работает одинаково для обоих видов
    // задач). В фоновой вкладке микрозадачи, в отличие от rAF, тоже выполняются исправно.
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      window.queueMicrotask(function () {
        scheduled = false;
        if (tryMove()) {
          everMoved = true;
          clearDeadline();
        }
      });
    }

    // Идемпотентно: если пилюля уже на месте, освежает стили и снимает срок; наблюдатель
    // при этом продолжает работать. Если пилюли нет — заводит наблюдателя и ставит срок.
    function start() {
      if (tryMove()) {
        everMoved = true;
        clearDeadline();
      }
      if (observer) return;
      observer = new MutationObserver(schedule);
      observer.observe(document.body, { childList: true, subtree: true });
      if (!everMoved) {
        deadline = window.setTimeout(function () {
          deadline = null;
          // Пилюля не нашлась ни разу за 15 с — приложение не загрузилось.
          // Только в этом случае снимаем наблюдателя, чтобы он не висел вечно.
          if (!everMoved && observer) {
            observer.disconnect();
            observer = null;
          }
        }, 15000);
      }
    }

    start();

    // Пересечение порога: слот меняется desktop <-> mobile, цель другая — включаемся заново.
    // matchMedia's 'change' fires only when crossing the breakpoint, not on every resize.
    desktopQuery.addEventListener('change', start);
    // Перерисовка секции шапки уносит слот вместе с пилюлей.
    document.addEventListener('shopify:section:load', start);
    // Возврат из bfcache и показ вкладки — поздние страховки на случай, если срок истёк.
    window.addEventListener('pageshow', start);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) start();
    });
  }

  function armPriceFade(container) {
    if (!container) return;
    container.classList.add('amore-price-fade');
    container.classList.remove('amore-price-ready');

    var moneyEl = container.querySelector('.money');
    var revealed = false;
    function reveal() {
      if (revealed) return;
      revealed = true;
      container.classList.add('amore-price-ready');
    }

    if (moneyEl) {
      var initialText = moneyEl.textContent;
      var observer = new MutationObserver(function () {
        if (moneyEl.textContent !== initialText) {
          reveal();
          observer.disconnect();
        }
      });
      observer.observe(moneyEl, { characterData: true, childList: true, subtree: true });
    }
    // Fallback: never hide the price indefinitely if Nova is slow, blocked, or absent.
    setTimeout(reveal, 900);
  }

  function initPriceFades() {
    var containers = document.querySelectorAll('[data-amore-price-fade]');
    for (var i = 0; i < containers.length; i++) {
      armPriceFade(containers[i]);
    }
  }

  /* Defence in depth, product template only (it exists to protect the golden/standard sticky
     "Add to bag" bar, which only render there). relocateNovaSelector() above is the primary
     fix: the pill should always land in a slot and give up its fixed positioning. But if a page
     is ever missing both slots (a theme-editor edit that drops the header block, a custom
     template, or simply the moment before relocation runs), it's still Nova's own fixed
     bottom-right element and can cover the mobile sticky "Add to bag" bar. This only nudges an
     UNrelocated pill clear of a currently-docked sticky bar, reading the bar's live height
     rather than a hardcoded one; it checks relocation status on every tick and backs off the
     moment the pill lands in a slot, so it never fights relocateNovaSelector() for the same
     element. */
  function armStickyFallback() {
    var stickyPanelSelector = '.golden-pdp__sticky, #ProductSubmitButton-Sticky';
    if (!document.querySelector(stickyPanelSelector)) return;

    var mobileQuery = window.matchMedia('(max-width: 749px)');

    function isRelocated(pill) {
      return !!pill.closest('[data-amore-currency-slot]');
    }

    // Space (px from the viewport bottom) a bar occupies IF it is a solid bar currently docked
    // at the bottom edge; 0 when hidden or translated off-screen.
    function dockedSpace(el) {
      var style = window.getComputedStyle(el);
      if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return 0;
      var viewportHeight = window.innerHeight;
      var rect = el.getBoundingClientRect();
      if (rect.height < 1) return 0;
      if (rect.bottom < viewportHeight - 2 || rect.top > viewportHeight - 2) return 0;
      return Math.max(0, Math.round(viewportHeight - rect.top));
    }

    function apply() {
      var pill = document.querySelector('.bacurr-cur-block');
      if (!pill || isRelocated(pill) || !mobileQuery.matches) {
        if (pill) pill.style.removeProperty('bottom');
        return;
      }
      var panels = [];
      var golden = document.querySelector('.golden-pdp__sticky');
      if (golden) panels.push(golden);
      var standard = document.getElementById('ProductSubmitButton-Sticky');
      if (standard) panels.push(standard);
      var space = 0;
      panels.forEach(function (el) {
        var s = dockedSpace(el);
        if (s > space) space = s;
      });
      if (space > 0) {
        pill.style.setProperty('bottom', space + 'px', 'important');
      } else {
        pill.style.removeProperty('bottom');
      }
    }

    /* CUR-05 шаг 3-доп, 22.08.2026: здесь стоял `requestAnimationFrame` с тем же
       замком, что был снят в `relocateNovaSelector()` — флаг поднимался ДО вызова
       rAF и снимался только внутри колбэка. Замер: в скрытой вкладке rAF не
       исполняется вовсе (0 кадров за 5 с при `document.hidden`, 9 кадров сразу
       после принудительной отрисовки), поэтому первый же вызов запирал планировщик
       и все последующие `schedule()` уходили в никуда.
       Здесь последствие мягче, чем в двух других местах: полоса покупки и пилюля
       живут на экране, а пока на экран не смотрят, их взаимное положение никого не
       трогает. Меняем всё равно — по единообразию и потому, что цена нулевая. */
    var pending = 0;
    function schedule() {
      if (pending) return;
      pending = 1;
      window.setTimeout(function () {
        pending = 0;
        apply();
      }, 0);
    }

    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden'],
    });
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('orientationchange', schedule, { passive: true });
    if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', schedule);
    schedule();
  }

  /* ============ ОТВЕТ В ТОМ ЖЕ КАДРЕ ==================================
     За текст денежного узла спорят два писателя: Nova пишет свой символ
     (`руб9.010`), мы переписываем в канон (`9.010 RUB`). Сумма в споре не
     участвует — только формат. Замер 19.08 на превью черновика: Nova пишет
     на 1-й миллисекунде после прохода конвертации, мы отвечали на 223–292-й,
     и эти двести миллисекунд — не работа, а ожидание своей очереди в опросе
     на 400 мс. Именно они и видны как мигание: три-пять оборотов за загрузку,
     по одному на каждый проход Nova.

     Поэтому опрос перестал быть основным механизмом. Основной — наблюдатель
     мутаций: запись Nova и наш ответ попадают в один checkpoint микрозадач,
     то есть ДО отрисовки кадра. Промежуточное состояние с символом браузер
     не рисует вовсе.

     Три условия, без которых это ломается:
     1. Наблюдатель на КОНТЕЙНЕР, не на узел. В каталоге 37 цен; тридцать семь
        наблюдателей — тридцать семь очередей записей. Здесь их два на всю
        страницу: `#MainContent` и панель корзины, оба с `subtree`.
     2. Защита от собственных записей. Наш проход сам меняет текст и без
        флага кормил бы наблюдателя своими же мутациями по кругу. На время
        прохода стоит `selfWriting`, а очередь наших записей снимается
        `takeRecords()` — иначе она приедет следующим checkpoint-ом.
     3. Опрос остаётся страховкой, но с интервалом 2000 мс вместо 400: он
        нужен на случаи, где мутации нет вовсе — смена валюты без перезаписи
        сумм, поздняя вставка виджета, ошибка в фильтре ниже. Это тот же
        код, просто реже.

     ЦЕНА ЗАМЕДЛЕННОЙ СТРАХОВКИ. Если наблюдатель запись пропустит — наш
     скрипт стартовал позже первой конвертации Nova, либо запись легла вне
     двух наблюдаемых контейнеров, — символ провисит до 2000 мс, вчетверо
     дольше прежнего худшего случая (400). Поэтому страховка двухступенчатая:
     разовый проход сразу при инициализации закрывает всё, что Nova успела
     написать ДО нас, а первые пять секунд опрос идёт с шагом 300 мс — это
     окно, в которое укладывается вся холодная цепочка Nova (замер: скрипт
     937→1080, курсы 1556→1902, страна 1909→2461 мс). Дальше шаг уходит на
     2000, где он уже ничего не стоит. */
  var POLL_FALLBACK_MS = 2000;
  var POLL_WARMUP_MS = 300;
  var WARMUP_WINDOW_MS = 5000;
  var moneyObservers = [];
  var selfWriting = false;
  var writeScheduled = false;

  function runMoneyWriters() {
    if (selfWriting) return;
    selfWriting = true;
    try {
      updateIdrLines();
      repairMixedMoneyNodes();
      updateCurrencyCodes();
    } finally {
      // Снимаем записи, которые породили сами: без этого следующий checkpoint
      // получит их как чужие и запустит проход ещё раз.
      for (var i = 0; i < moneyObservers.length; i++) moneyObservers[i].takeRecords();
      selfWriting = false;
    }
  }

  function scheduleMoneyWrite() {
    if (writeScheduled || selfWriting) return;
    writeScheduled = true;
    // Микрозадача, а не rAF: она отрабатывает в конце текущей задачи, то есть
    // раньше стиля и отрисовки. Кадр с символом не доезжает до экрана.
    Promise.resolve().then(function () {
      writeScheduled = false;
      runMoneyWriters();
    });
  }

  function touchesMoney(records) {
    for (var i = 0; i < records.length; i++) {
      var record = records[i];
      var target = record.target;
      var el = target.nodeType === 1 ? target : target.parentElement;
      if (el && el.closest && el.closest('.money')) return true;
      for (var j = 0; j < record.addedNodes.length; j++) {
        var node = record.addedNodes[j];
        var added = node.nodeType === 1 ? node : node.parentElement;
        if (!added || !added.closest) continue;
        if (added.closest('.money')) return true;
        if (added.querySelector && added.querySelector('.money')) return true;
      }
    }
    return false;
  }

  function watchMoneyContainers() {
    /* Бутстрап из <head> уже слушает `document.documentElement` и с первой
       секунды сам нормализует своим коротким проходом. Если он на месте —
       второго наблюдателя не заводим, а передаём ему полный проход: с этого
       момента пишет он же, но авторитетным кодом отсюда. */
    var boot = window.__amoreMoneyBoot;
    if (boot && boot.observer) {
      boot.writer = runMoneyWriters;
      moneyObservers.push(boot.observer);
      return;
    }

    var roots = [document.getElementById('MainContent'), document.querySelector('cart-drawer')];
    for (var i = 0; i < roots.length; i++) {
      if (!roots[i]) continue;
      var observer = new MutationObserver(function (records) {
        if (selfWriting) return;
        if (!touchesMoney(records)) return;
        scheduleMoneyWrite();
      });
      observer.observe(roots[i], { childList: true, characterData: true, subtree: true });
      moneyObservers.push(observer);
    }
  }

  function watchChosenCurrency() {
    // Nova не отдаёт события и гасит всплытие своих кликов, поэтому смену
    // валюты по-прежнему ловит опрос — но теперь только как страховка.
    watchMoneyContainers();

    // Метка для замера: во сколько наш слой встал относительно цепочки Nova.
    // Читается снаружи как performance.getEntriesByName('amore-currency-init').
    try {
      performance.mark('amore-currency-init');
    } catch (e) {}

    // Разовый проход: всё, что Nova успела написать до нашего старта,
    // наблюдатель уже не увидит — эти мутации прошли без нас.
    runMoneyWriters();

    var warmup = setInterval(runMoneyWriters, POLL_WARMUP_MS);
    setTimeout(function () {
      clearInterval(warmup);
      setInterval(runMoneyWriters, POLL_FALLBACK_MS);
    }, WARMUP_WINDOW_MS);
  }

  function novaRefreshConversion() {
    if (window.baCurr && typeof window.baCurr.refreshConversion === 'function') {
      window.baCurr.refreshConversion();
    }
  }

  // True once every non-IDR-settlement `.money` node on the page is either already IDR-labeled
  // (nothing to convert) or has been converted by Nova (`.bacurr-money`, non-IDR text). Used to
  // decide whether the bounded post-cartUpdate retry window needs the one-shot fallback click.
  function surfacePricesConverted(currency) {
    if (currency === 'IDR') return true;
    var moneyNodes = document.querySelectorAll('.money');
    if (!moneyNodes.length) return true;
    return Array.prototype.every.call(moneyNodes, function (moneyNode) {
      if (moneyNode.closest('[data-amore-idr-line]')) return true;
      return moneyNode.classList.contains('bacurr-money') && !isIdrMoneyText(moneyNode.textContent);
    });
  }

  function findCurrencyMover(currency) {
    var movers = document.querySelectorAll('li.currMovers');
    for (var i = 0; i < movers.length; i++) {
      var mover = movers[i];
      if (normalizeCurrency(mover.textContent) === currency || normalizeCurrency(mover.id) === currency) {
        return mover;
      }
    }
    return null;
  }

  /* Restart Nova's conversion after Dawn replaces cart sections (quantity change, line removal,
     etc.) — Nova sometimes lags or misses the replacement, leaving `.money` nodes reading raw
     IDR under a pill that still says USD/EUR (see the `Rp 10 200 000 USD` screenshot this was
     diagnosed from). Primary trigger is Dawn's own `cartUpdate` pub/sub event; a MutationObserver
     on the cart root is only a fallback for the (unexpected) case that pub/sub isn't loaded. */
  function restartNovaOnCartUpdate() {
    var cycleTimer = null;
    var cycleScheduled = false;

    function runCycle() {
      if (cycleTimer) {
        clearInterval(cycleTimer);
        cycleTimer = null;
      }

      /* Валюту здесь тоже не угадываем. Подстановка 'IDR' при неизвестной
         валюте приводила бы к клику по пункту «рупии» в запасном пути ниже —
         то есть к молчаливой смене валюты покупателю. */
      var currency = currentNovaCurrency();
      var fallbackClicked = false;

      novaRefreshConversion();
      repairMixedMoneyNodes();
      updateCurrencyCodes();

      var elapsed = 0;
      var step = 160;
      var maxWait = 800;
      cycleTimer = setInterval(function () {
        elapsed += step;
        repairMixedMoneyNodes();
        updateCurrencyCodes();
        var converged = surfacePricesConverted(currency);
        if (converged || elapsed >= maxWait) {
          clearInterval(cycleTimer);
          cycleTimer = null;
          if (!converged && !fallbackClicked && currency) {
            fallbackClicked = true;
            var mover = findCurrencyMover(currency);
            if (mover) mover.click();
          }
          repairMixedMoneyNodes();
          updateCurrencyCodes();
        }
      }, step);
    }

    /* CUR-05 шаг 3-доп, 22.08.2026: тот же замок, и здесь он был ВИДИМЫМ для
       покупателя. Замер на черновике, вкладка скрыта (`document.hidden === true`),
       валюта USD, настоящие клики по «+» в корзине:
         первое обновление  — суммы пересчитались, 473 USD / 828 USD;
         второе обновление  — итоги вернулись СЫРЫМИ рупиями, `Rp 16 100 000` и
                              `Rp 9 800 000`, рядом с позициями в долларах,
                              и держались так 18 с, не починившись;
         скриншот (форсированная отрисовка) — тут же 906 USD / 552 USD.
       Механизм: первое обновление подняло `cycleScheduled` и ушло ждать кадра,
       которого в скрытой вкладке нет; второе обновление получило `return` на
       поднятом флаге, и чинить рассинхрон стало некому до первой отрисовки.
       `setTimeout` в фоне тикает, поэтому цикл сходимости успевает отработать ДО
       того, как человек вернётся на вкладку, а не начинается в момент возврата. */
    function scheduleCycle() {
      if (cycleScheduled) return;
      cycleScheduled = true;
      window.setTimeout(function () {
        cycleScheduled = false;
        runCycle();
      }, 0);
    }

    /* R1: смена варианта на карточке — тот же случай, что подмена секций
       корзины: денежный узел получает новый текст, и Nova о нём не знает.
       Отдаём наружу ТОТ ЖЕ цикл с повторами и проверкой сходимости, а не
       одиночный refreshConversion(): Nova асинхронна, и один синхронный
       вызов успевает отработать раньше неё. */
    window.amoreRestartConversion = scheduleCycle;

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleCycle);
      return;
    }

    // Fallback only: no Dawn pub/sub available. Watch the cart root for section-replacement
    // childList changes, ignoring mutations inside nodes this file itself owns so the observer
    // never reacts to its own updateCurrencyCodes()/updateIdrLines()/pill-relocation writes.
    var cartRoot =
      document.getElementById('main-cart-footer') || document.querySelector('cart-items, #CartDrawer, .cart-items');
    if (!cartRoot) return;

    var ownedSelector = '[data-amore-currency-code], [data-amore-idr-line], .bacurr-cur-block';
    var fallbackObserver = new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (mutation) {
        if (mutation.type !== 'childList') return false;
        var target = mutation.target;
        return !(target.closest && target.closest(ownedSelector));
      });
      if (relevant) scheduleCycle();
    });
    fallbackObserver.observe(cartRoot, { childList: true, subtree: true });
  }

  function init() {
    relocateNovaSelector();
    armStickyFallback();
    initPriceFades();
    updateIdrLines();
    watchChosenCurrency();
    restartNovaOnCartUpdate();

    /* CURRENCY CODE: run the label sync on the same triggers as updateIdrLines
       (initial paint, the ongoing poll, and variant swaps), on every page. */
    updateCurrencyCodes();
    document.addEventListener('variant:change', updateCurrencyCodes);

    // Re-arm price fades after a variant swap re-renders the price block (Dawn dispatches
    // this event; see assets/product-info.js / templates/product.json custom_liquid_HcFqPG).
    document.addEventListener('variant:change', function () {
      initPriceFades();
      updateIdrLines();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
